import { combineEpics, Epic, ofType } from 'redux-observable'
import { map } from 'rxjs'
import { createInvokeEpic } from '../../signalr/createInvokeEpic'
import { createStreamEpic } from '../../signalr/createStreamEpic'
import {
  clearPassiveOrders,
  fetchPassiveOrders,
  unsubscribePassiveOrders
} from './actions'
import {
  cancelPassiveOrderDefinition,
  fetchPassiveOrdersDefinition,
  resubmitOrderDefinition
} from './definition'

const setSelectedUserEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('users.setSelectedUser'),
    map(() => {
      return clearPassiveOrders()
    })
  )

const clearPassiveOrdersEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('passiveOrders.clearPassiveOrders'),
    map(() => {
      return unsubscribePassiveOrders()
    })
  )

const unsubscribePassiveOrdersEpic: Epic = (action$, state$) =>
  action$.pipe(
    ofType('passiveOrders.unsubscribePassiveOrders'),
    map(() => {
      return fetchPassiveOrders()
    })
  )

export default combineEpics(
  createStreamEpic(
    'passiveOrders.fetchPassiveOrders',
    fetchPassiveOrdersDefinition
  ),
  setSelectedUserEpic,
  clearPassiveOrdersEpic,
  unsubscribePassiveOrdersEpic,
  createInvokeEpic(
    'passiveOrders.cancelPassiveOrder',
    cancelPassiveOrderDefinition
  ),
  createInvokeEpic(
    'passiveOrders.createOrderFromPassiveOrder',
    resubmitOrderDefinition
  )
)
